import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface MetricCardSkeletonProps {
    showIcon?: boolean;
    showMetadataIcon?: boolean;
    showIndexBadge?: boolean;
}

const MetricCardSkeleton = ({
    showIcon = true,
    showMetadataIcon = true,
    showIndexBadge = false,
}: MetricCardSkeletonProps) => {
    return (
        <div className="relative overflow-hidden rounded-xl border bg-white">
            <div className="p-3">
                <div className="mb-1 flex items-start justify-between">
                    <div className="flex items-center gap-2">
                        {showIcon && (
                            <Skeleton
                                height={44}
                                width={44}
                                borderRadius={8}
                            />
                        )}

                        <Skeleton height={34} width={96} />
                    </div>

                    {showMetadataIcon && (
                        <Skeleton
                            height={24}
                            width={24}
                            borderRadius={6}
                        />
                    )}
                </div>

                <div className="space-y-1">
                    <Skeleton height={14} width="70%" />
                    <Skeleton height={11} width="90%" />

                    {showIndexBadge && (
                        <Skeleton
                            height={16}
                            width={40}
                            borderRadius={8}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default MetricCardSkeleton;